/*
 * @author: René Panák (rene.panak@seznam.cz)
 */

'use strict';

var htmlSpinnerOverlay = '\
<div class="text-center bg-faded-dark position-absolute w-100 h-100" style="z-index: 1060; left: 0; top: 0; right: 0; bottom: 0;">\
    <div class="spinner-border m-5" role="status"><span class="sr-only">Loading...</span></div>\
</div>\
';

/**
 * Ported from Thematronic -> ZoOo -> CZ
 * @param {window.$|$} $target
 * @param {function} functionDiscardCallback
 * @param {boolean} boolDefaultVisible
 * @param {boolean} boolDisableText
 * @returns {window.$|$}
 */
function createSpinner($target, functionDiscardCallback, boolDefaultVisible, boolDisableText) {

    if (!$target || !$target.length) {

        return $;
    }

    $target.addClass('r_spinable');

    var $eSpinner = $target.find('.r_spinner');
    if ($eSpinner.length) {

        return $eSpinner;
    }


    //var $spinner = $('<div class="r_spinner"><div class="r_spinner_spinner_wrap"><div class="r_spinner_spinner"></div></div></div>');
    var $spinner = $(htmlSpinnerOverlay);
    var $si = $('<div class="r_spinner_info"></div>');

    //console.log('boolDisableText', boolDisableText);
    if (!boolDisableText) {
//        $si.attr('title', self.strip(self.lang.spinnerText));
//        $si.html(self.lang.spinnerText);
    }
    $spinner.append($si);

    if (typeof functionDiscardCallback === "function") {

        var $sd = $('<a href="javascript:void(0);" class="r_spinner_discard" title="Discard"><i class="fa fa-times"></i></a>');
        $sd.click(functionDiscardCallback);
        $spinner.prepend($sd);
    }

    //$target.append($spinner);
    $target.addClass('position-relative');
    $target.prepend($spinner);

    if (!boolDefaultVisible) {

        $spinner.hide();
    }

    return $spinner;
}

(function (window, document, $, czTheme, console, undefined) {
    'use strict';

    /* PROTO */

    if (0) {
        /* AJAX call complete template */

        var url = `/ajax-pages/added-to-cart/`; // ok
        //var url = `/404/`; // failing
        var requestData = {};
        $.get(url, requestData)
                .done(function (responseData, textStatus, jqXHR) {
                    console.warn('done');
                    console.info('responseData');
                    console.log(responseData);
                    console.info('textStatus');
                    console.log(textStatus);
                    console.info('jqXHR');
                    console.log(jqXHR);
                })
                .fail(function (jqXHR, textStatus, httpStatus) {
                    console.warn('fail');
                    console.info('jqXHR');
                    console.log(jqXHR);
                    console.info('textStatus');
                    console.log(textStatus);
                    console.info('httpStatus');
                    console.log(httpStatus);
                })
                .always(function (a, textStatus, b) {
                    // textStatus is only stable parameter
                    console.warn('always');
                    console.info('textStatus');
                    console.log(textStatus);
                })
                ;
    }

    if (0) {
        /* selector conditional event template */

        function selectorConditionalEvent(selector) {
            var $targetElement = $(selector);
            if (!$targetElement.length) {
                return;
            }
            $targetElement.on('click', function (event) {
                console.log(event);
            });
        }
    }

    /* /PROTO */


    /* COMMON */

    var htmlSpinner = '\
<div class="text-center">\
    <div class="spinner-border m-5" role="status"><span class="sr-only">Loading...</span></div>\
</div>\
';
    var htmlSpinnerOverlay = '\
<div class="d-flex justify-content-center bg-faded-dark position-absolute w-100 h-100" style="z-index: 1060; left: 0; top: 0; right: 0; bottom: 0;">\
    <div class="spinner-border m-5" role="status"><span class="sr-only">Loading...</span></div>\
</div>\
';
    var htmlLoadfail = '\
<div class="text-center">\
    <div class="text-danger m-5" role="status"><i class="czi-pot"></i><span class="sr-only">Failed!</span></div>\
</div>\
';

    var toastContainer = $('#main-toast-container');
    var toastSuccess = $('#def-toast-success');
    var toastDanger = $('#def-toast-danger');
    var toastWarning = $('#def-toast-warning');
    var toastInfo = $('#def-toast-info');

    /**
     *
     * @param {string} type
     * @param {string} message
     * @param {string} header
     * @returns {undefined}
     */
    function message2toast(type, message, header = '') {
        //console.info(type, message, header);

        let toastProto = null;
        switch (type) {
            case 'success':
                toastProto = toastSuccess;
                break;
            case 'warning':
                toastProto = toastWarning;
                break;
            case 'danger':
                toastProto = toastDanger;
                break;
            case 'info':
            default:
                toastProto = toastInfo;
        }

        let toastCurrent = toastProto.clone(true);
        //console.log(toastCurrent);
        toastCurrent.attr('id', '');
        toastCurrent.find('.toast-body').html(message);
        toastContainer.prepend(toastCurrent);
        toastCurrent.toast('show');
    }

    /**
     *
     * @param {array} messages
     * @returns {undefined}
     */
    function messages2toasts(messages) {
        //console.info(messages);
        messages.forEach(message => message2toast(message[0], message[1]));
    }

    /**
     *
     * @returns {undefined}
     */
    function runToasts() {
        let toasts = toastContainer.find('.toast:not(.toast-static-noauto)');
        //toasts.toast(); // init only (dismissable)
        toasts.toast('show'); // init, show (with delayed dismiss)
    }

    /**
     *
     * @param {jQueryElement} element
     * @returns {undefined}
     */
    function attachSpinner(element) {
        element.addClass('position-relative');
        element.prepend(htmlSpinnerOverlay);
    }

    /**
     * target.html(source.html());
     * OR
     * target.replaceWith(responseData)
     *
     * @param {jQuery} target
     * @param {string} selector
     * @param {string} responseData
     * @returns {undefined}
     */
    function myReplaceWith(target, selector, responseData) {
        /* if possible, refresh only content of `selector` */
        let $rd = $(responseData);
        //console.log($rd);
        let x_source = null;
        let source = null;
        if ($rd.is(selector)) {
            source = $rd;
        } else if ((x_source = $rd.find(selector)).length) {
            source = x_source;
        }
        //console.log(source);

        if (source && source.length) {
            target.html(source.html());
        } else {
            target.replaceWith(responseData);
        }
        czTheme.lazyloadUpdate();
    }

    /**
     * AKA jQuery.param
     * // jQuery.serialize() = jQuery.param(jQuery.serializeArray())
     * @link jquery/src/serialize.js:59
     * @param {array} arr
     * @returns {String}
     */
    function array2query(arr) {
        let s = [];
        // Serialize the form elements
        $.each(arr, (i, e) => {
            s[s.length] = e.name + "=" + encodeURIComponent(e.value == null ? "" : e.value);
        });
        // Return the resulting serialization
        return s.join("&");
    }

    /**
     * AKA jQuery.serialize()
     * @param {jQuery} form
     * @returns {String}
     */
    function form2query(form) {
        return array2query(form.serializeArray());
    }

    /*
     * ******
     * AJAXed
     * ******
     */

    let RedirEnum = {
        none: "none",
        success: "success",
        fail: "fail",
        both: "both",
    };
    let SuppressEnum = {
        none: "none",
        success: "success",
        fail: "fail",
        both: "both",
    };

    /**
     * Perform async submit of form. nfw g_ or p_ forms.
     * Target must implement INFWFormActionResponse.
     *
     * nfwAjaxed_callbackPresubmit(jQuery event, DOMObject form, function fncContinue):bool
     * nfwAjaxed_callbackSuccess(jQuery Object, responseData):void
     * nfwAjaxed_callbackFail(jQuery event, Object responseData):void
     *
     * @param {string} selector
     * @returns {undefined}
     */
    function interactionAJAXedForm(selector) {

        $('body').on('submit', selector, (event) => {
            console.info(`interactionAJAXedForm`);
            //console.log(event);
            let form = event.currentTarget,
                    //action = form.action, // colliding with input[name=action] !!!
                    action = form.attributes.action ? form.attributes.action.value : '';
            console.log({
                event: event,
                form: form,
                action: action
            });

            let par = {
                redir: form.dataset.nfwAjaxed_redir || RedirEnum.success,
                suppress: form.dataset.nfwAjaxed_suppress || SuppressEnum.none,
                cbk_presubmit: form.dataset.nfwAjaxed_callbackPresubmit || '',
                cbk_success: form.dataset.nfwAjaxed_callbackSuccess || '',
                cbk_fail: form.dataset.nfwAjaxed_callbackFail || ''
            };
            console.log(par);

            let fncContinue = function () {

                let data = form2query($(form)); // how to do it without jQuery??
                if (par.redir === RedirEnum.success) {
                    data += '&flashOnSuccess=1';
                }
                if (par.redir === RedirEnum.fail) {
                    data += '&flashOnNonSuccess=1';
                }
                console.log({
                    data: data
                });

                let xhr = null;
                if (form.method === 'post') {
                    xhr = $.post(action, data);
                } else {
                    xhr = $.get(action, data);
                }
                xhr.done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);

                    if (typeof responseData !== 'object') {
                        console.error("AJAXedForm: 'responseData' is not an object!");
                        console.log(responseData);
                        return;
                    } else if (responseData.success !== true) {
                        console.log(responseData);
                    }

                    if (
                            par.suppress === SuppressEnum.both ||
                            responseData.success && par.suppress === SuppressEnum.success ||
                            !responseData.success && par.suppress === SuppressEnum.fail
                            ) {
                        console.log('AJAXedForm: messages suppressed.', responseData.messages);
                    } else {
                        messages2toasts(responseData.messages);
                    }

                    if (
                            responseData.success && par.redir === RedirEnum.success ||
                            !responseData.success && par.redir === RedirEnum.fail
                            ) {
                        window.location.href = responseData.redirect;
                        return;
                    }

                    if (responseData.success && par.cbk_success) {
                        _tryCallNFWCallback(par.cbk_success, event, responseData);
                    }
                    if (!responseData.success && par.cbk_fail) {
                        _tryCallNFWCallback(par.cbk_fail, event, responseData);
                    }
                }).fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Failed submitting form!');
                    console.error('Failed submitting form!');
                    console.error(jqXHR, textStatus, httpStatus);
                });
            };

            if (!par.cbk_presubmit || par.cbk_presubmit && _tryCallNFWCallback(par.cbk_presubmit, event, form, fncContinue) === true) {
                fncContinue();
            } else {
                console.log(`AJAXedForm: waiting for _tryCallNFWCallback(${par.cbk_presubmit})...`, );
            }

            return false; // do not perform reload
        });
    }

    /**
     * Perform async call of link. Preferably nfw g_ forms.
     * Target must implement INFWFormActionResponse.
     * @param {string} selector
     * @returns {undefined}
     */
    function interactionAJAXedLink(selector) {

        $('body').on('click', selector, (event) => {
            console.info(`interactionAJAXedLink`);
            //console.log(event);

            let link = event.currentTarget;
            console.log({
                event: event,
                link: link
            });

            let par = {
                redir: link.dataset.nfwAjaxed_redir || RedirEnum.success,
                suppress: link.dataset.nfwAjaxed_suppress || SuppressEnum.none,
                //cbk_presubmit: link.dataset.nfwAjaxed_callbackPresubmit || '',
                cbk_success: link.dataset.nfwAjaxed_callbackSuccess || '',
                cbk_fail: link.dataset.nfwAjaxed_callbackFail || ''
            };
            console.log(par);

            let href = link.href;
            if (par.redir === RedirEnum.success) {
                href += '&flashOnSuccess=1';
            }
            if (par.redir === RedirEnum.fail) {
                href += '&flashOnNonSuccess=1';
            }
            console.log({
                href: href
            });

            let xhr = $.get(href);
            xhr.done((responseData, textStatus, jqXHR) => {
                //console.log(responseData);

                if (typeof responseData !== 'object') {
                    console.error("AJAXedLink: 'responseData' is not an object!");
                    console.log(responseData);
                    return;
                } else if (responseData.success !== true) {
                    console.log(responseData);
                }

                if (
                        par.suppress === SuppressEnum.both ||
                        responseData.success && par.suppress === SuppressEnum.success ||
                        !responseData.success && par.suppress === SuppressEnum.fail
                        ) {
                    console.log('AJAXedLink: messages suppressed.', responseData.messages);
                } else {
                    messages2toasts(responseData.messages);
                }

                if (
                        responseData.success && par.redir === RedirEnum.success ||
                        !responseData.success && par.redir === RedirEnum.fail
                        ) {
                    window.location.href = responseData.redirect;
                    return false;
                }

                if (responseData.success && par.cbk_success) {
                    _tryCallNFWCallback(par.cbk_success, event, responseData);
                }
                if (!responseData.success && par.cbk_fail) {
                    _tryCallNFWCallback(par.cbk_fail, event, responseData);
                }
            }).fail((jqXHR, textStatus, httpStatus) => {
                //message2toast('danger', 'Failed submitting link!');
                console.error('Failed submitting link!');
                console.error(jqXHR, textStatus, httpStatus);
            });

            return false; // do not perform reload
        });
    }

    /*
     * *******
     * /AJAXed
     * *******
     */

    /**
     *
     * @param {string} eventName
     * @param {string} selector selector of trigger element
     * @param {string} rootSelector element to append event to
     * @returns {undefined}
     */
    function interactionFormSubmitOn(eventName, selector, rootSelector = null) {

        let $targetElement = null;
        if (rootSelector !== null) {
            $targetElement = $(rootSelector);
            if (!$targetElement.length) {
                return;
            }
        } else {
            $targetElement = $('body');
        }
        $targetElement.on(eventName, selector, (event) => {
            console.info(`interactionFormSubmitOn`);
            //console.log(event);
            let element = $(event.currentTarget);
            let form = element.parents('form');
            console.log({
                event: event,
                element: element,
                form: form
            });
            form.submit();
        });
    }

    /**
     *
     * @param {string} selector
     * @returns {undefined}
     */
    function interactionStoreOnChange(selector) {

        $('body').on('change', selector, (event) => {
            console.info(`interactionStoreOnChange`);
            //console.log(event);
            let form = event.currentTarget,
                    //action = form.action, // colliding with input[name=action] !!!
                    action = form.attributes.action ? form.attributes.action.value : '';

            let data = form2query($(form)); // how to do it without jQuery??
            if (1) {
                data += '&storeOnly=1';
            }
            console.log({
                data: data
            });

            let xhr = null;
            if (form.method === 'post') {
                xhr = $.post(action, data);
            } else {
                xhr = $.get(action, data);
            }
            xhr.done((responseData, textStatus, jqXHR) => {
                console.log('interactionStoreOnChange', responseData);
            }).fail((jqXHR, textStatus, httpStatus) => {
                //message2toast('danger', 'Failed storing form!');
                console.error('Failed storing form!');
                console.error(jqXHR, textStatus, httpStatus);
            });
        });
    }

    /**
     *
     * @param {string} selector
     * @returns {undefined}
     */
    function interactionCollapsibleSubmenu(selector) {

        let $targetElement = $(selector);

        $targetElement.on('click', 'a[data-toggle="collapse"]', (event) => {
            event.preventDefault();
            event.stopPropagation();
            let ele = $(event.currentTarget);
            //$(ele.data('parent')).find('.panel-collapse.in').collapse('hide'); //hide others
            $(ele.attr('href')).collapse('toggle');
        });

        $targetElement.on('click', (event) => {
            let stop = !(event.target.tagName === 'A' || event.target.parentElement.tagName === 'A');
            if (stop) {
                event.preventDefault();
                event.stopPropagation();
                console.log({
                    'nfwEle-submenu-collapse-stopper': 'stopped propagation of click!',
                    event
                });
            }
        });
    }

    /* /COMMON */


    /* MODALS */

    /**
     *
     * @param {string} selector
     * @returns {undefined}
     */
    function modalOrderDetail(selector) {
        let $targetElement = $(selector);
        if (!$targetElement.length) {
            return;
        }
        $targetElement.on('show.bs.modal', function (event) {
            let button = $(event.relatedTarget);
            let modal = $(this);

            let order_id = button.data('order-id');

            let url = `/ajax-pages/order-detail/${order_id}/modal/`;
            let modalContent = modal.find('.modal-content');

            modalContent.html(htmlSpinner); // reset to spinner before every fetch

            $.get(url)
                    .done((responseData, textStatus, jqXHR) => {
                        modalContent.html(responseData);
                        czTheme.lazyloadUpdate();
                    })
                    .fail((jqXHR, textStatus, httpStatus) => {
                        modalContent.html(htmlLoadfail);
                    })
                    ;
        });
    }

    /**
     *
     * @param {string} selector
     * @returns {undefined}
     */
    function modalProductQuick(selector) {
        let $targetElement = $(selector);
        if (!$targetElement.length) {
            return;
        }
        $targetElement.on('show.bs.modal', function (event) {
            let button = $(event.relatedTarget);
            let modal = $(this);

            let zbozi_id = button.data('zbozi-id');

            let url = `/ajax-pages/product-quick/${zbozi_id}/modal/`;
            let modalContent = modal.find('.modal-content');

            modalContent.html(htmlSpinner); // reset to spinner before every fetch

            $.get(url)
                    .done((responseData, textStatus, jqXHR) => {
                        modalContent.html(responseData);
                        czTheme.lazyloadUpdate();
                    })
                    .fail((jqXHR, textStatus, httpStatus) => {
                        modalContent.html(htmlLoadfail);
                    })
                    ;
        });
    }

    /**
     *
     * @param {string} selector
     * @param {bool} isEdit
     * @returns {undefined}
     */
    function modalAddress(selector, isEdit = false) {
        let $targetElement = $(selector);
        if (!$targetElement.length) {
            return;
        }
        $targetElement.on('show.bs.modal', function (event) {
            let button = $(event.relatedTarget);
            let modal = $(this);
            let modalContent = modal.find('.modal-content');
            modalContent.html(htmlSpinner); // reset to spinner before every fetch

            let url = '';
            if (isEdit) {
                let address_id = button.data('address-id');
                url = `/ajax-pages/address-edit/${address_id}/modal/`;
            } else {
                let address_type = button.data('address-type');
                url = `/ajax-pages/address-add/${address_type}/modal/`;
            }

            $.get(url)
                    .done((responseData, textStatus, jqXHR) => {
                        modalContent.html(responseData);
                        czTheme.formValidationBind();
                    })
                    .fail((jqXHR, textStatus, httpStatus) => {
                        modalContent.html(htmlLoadfail);
                    })
                    ;
        });
    }

    /**
     *
     * @param {string} selector
     * @returns {undefined}
     */
    function modalShippingPickup(selector) {
        let $targetElement = $(selector);
        if (!$targetElement.length) {
            return;
        }

        $targetElement.on('show.bs.modal', function (event) {
            let modal = $(this);
            console.log('modalShippingPickup show', modal, event);
        });

        $targetElement.on('hide.bs.modal', function (event) {
            let modal = $(this);
            console.log('modalShippingPickup hide', modal, event);
            //reloadPgCheckoutShipping();
        });

        $targetElement.on('hidden.bs.modal', function (event) {
            let modal = $(this);
            console.log('modalShippingPickup hidden', modal, event);
            reloadPgCheckoutShipping();
        });
    }

    /* /MODALS */


    /* RELOADS */

    /**
     *
     * @returns {undefined}
     */
    function reloadLayoutHeaderCart() {
        let selector = '#module-cart-header';
        let target = $(selector);
        if (!target.length) {
            return;
        }

        let url = `/ajax-pages/cart-header/`;

        attachSpinner(target);

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);
                    myReplaceWith(target, selector, responseData);
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Reloading #module-cart-header failed!');
                    console.error('Reloading #module-cart-header failed!');
                })
                ;
    }

    /**
     *
     * @returns {undefined}
     */
    function reloadLayoutToolbarCart() {
        let selector = '#module-cart-toolbar';
        let target = $(selector);
        if (!target.length) {
            return;
        }

        let url = `/ajax-pages/cart-toolbar/`;

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);
                    target.replaceWith(responseData);
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Reloading #module-cart-toolbar failed!');
                    console.error('Reloading #module-cart-toolbar failed!');
                })
                ;
    }

    /**
     *
     * @returns {undefined}
     */
    function reloadLayoutCart() {
        reloadLayoutHeaderCart();
        reloadLayoutToolbarCart();
    }

    /**
     *
     * @param {int} categoryId
     * @param {string} queryString
     * @returns {undefined}
     */
    function reloadLayoutToolbarFilters(categoryId, queryString) {
        let selector = '#nfwMod-category-filters-toolbar';
        let target = $(selector);
        if (!target.length) {
            return;
        }

        let url = `/ajax-pages/category-filters-toolbar/${categoryId}/${queryString}`;

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);
                    myReplaceWith(target, selector, responseData);
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Reloading #nfwMod-category-filters-toolbar failed!');
                    console.error('Reloading #nfwMod-category-filters-toolbar failed!');
                })
                ;
    }

    /* /RELOADS */


    /* ADD TO CART */

    /**
     *
     * @returns {undefined}
     */
    function showModalAddedToCart() {
        let modal = $('#modal-added-to-cart');
        modal.modal('show');

        let url = `/ajax-pages/added-to-cart/`;
        let modalContent = modal.find('.modal-content');

        modalContent.html(htmlSpinner); // reset to spinner before every fetch

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    modalContent.html(responseData);
                    czTheme.carousel(); // handle carousel
                    czTheme.lazyloadUpdate();
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    modalContent.html(htmlLoadfail);
                })
                ;
    }

    /* /ADD TO CART */


    /* SEARCH DYNAMIC */

    /**
     *
     * @type $|_$
     */
    var resultWindow = null;
    /**
     *
     * @type int
     */
    var resultWindowTimeoutID = null;

    /**
     *
     * @param {string} method
     * @param {type} value
     * @returns {undefined}
     */
    function searchDynamicResultWindow(method, value = null) {
        //console.log('searchDynamicResultWindow', method);

        let selectorResultWindow = '.nfwEle-searchResults';
        let selectorResultDefault = '.nfwEle-searchResults-default';

        if (resultWindow === null) {

            resultWindow = $(selectorResultWindow);
            let resultDefault = $(selectorResultDefault);
            resultWindow.data('defaultHTML', resultDefault.html());
            resultWindow.html(resultWindow.data('defaultHTML'));
        }

        if (method === 'get') {

            //return resultWindow; // same as do-nothing
        } else if (method === 'show') {

            resultWindow.show();
        } else if (method === 'hide') {

            resultWindow.hide();
        } else if (method === 'hide-discard') {

            if (resultWindowTimeoutID) {
                // clear
                clearTimeout(resultWindowTimeoutID);
            }
        } else if (method === 'hide-delayed') {

            // clear previous
            searchDynamicResultWindow('hide-discard');
            // set new
            resultWindowTimeoutID = setTimeout(searchDynamicResultWindow, 300, 'hide'); // timeouted
        } else if (method === 'set-default') {

            resultWindow.html(resultWindow.data('defaultHTML'));
        } else if (method === 'html') {

            resultWindow.html(value);
            czTheme.lazyloadUpdate();
        } else if (method === 'prepend') {

            resultWindow.prepend(value);
        }

        return resultWindow;
    }

    /**
     *
     * @param {string} value
     * @returns {undefined}
     */
    function searchDynamic(value) {
        let url = '/ajax-pages/search-dynamic/';

        if (!value) {
            searchDynamicResultWindow('set-default');
            searchDynamicResultWindow('hide');
        }
        if (value.length < 2) {
            searchDynamicResultWindow('set-default');
            //searchDynamicResultWindow('hide');
            return;
        }

        let requestData = {
            'search': value,
        };
        searchDynamicResultWindow('prepend', htmlSpinnerOverlay);
        searchDynamicResultWindow('show');
        //return; // when testing spinner
        $.get(url, requestData)
                .done((responseData, textStatus, jqXHR) => {
                    searchDynamicResultWindow('html', responseData);
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    searchDynamicResultWindow('html', htmlLoadfail);
                })
                .always((a, textStatus, b) => {
                })
                ;
    }

    /**
     *
     * @param {string} selector
     * @returns {undefined}
     */
    function interactionSearchDynamic(selector) {

        let $eForm = $(selector);
        if (!$eForm.length) {
            return;
        }
        let selectorInput = '[name="search"]';
        let timeoutMS = 400;
        let timeoutID = null;

        let $eInput = $eForm.find(selectorInput);
        let $eEmptier = $eForm.find('.nfwEle-searchEmptier');

        if ($eInput.val() !== '') {
            $eEmptier.show();
        } else {
            $eEmptier.hide();
        }

        $eInput.on('focus', (event) => {
            //console.log(event);
            searchDynamicResultWindow('show');
        });
        $eInput.on('blur', (event) => {
            //console.log(event);
            searchDynamicResultWindow('hide-delayed');
        });
        $eForm.on('click', (event) => {
            //console.log(event);
            searchDynamicResultWindow('hide-discard');
            $eForm.find(selectorInput).focus();
        });
        $eEmptier.on('click', (event) => {
            //console.log(event);
            $eInput.val('');
            $eInput.keyup();
        });

        let prevValue = null;
        $eInput.on('keyup', (event) => {
            //console.log(event);

            let $input = $(event.currentTarget);
            let value = $input.val();
            $eInput.val(value); // ensure that all search inputs have same value

            if ($eInput.val() !== '') {
                $eEmptier.show();
            } else {
                $eEmptier.hide();
            }

            if (value === prevValue) {
                // do not perform search if not changed keyword
                return;
            }
            prevValue = value;

            if (true) {
                // non-splittable (~atomic)
                if (timeoutID) {
                    // clear previous
                    clearTimeout(timeoutID);
                }
                // set new
                timeoutID = setTimeout(searchDynamic, timeoutMS, value); // timeouted
            } else {
                searchDynamic(value); // direct
            }
        });
//        $eInput.on('keypress', function (event) {
//            // not gonna happen - not reacting to backspace... (delete char)
//            console.log(event);
//        });
    }

    /* /SEARCH DYNAMIC */


    /* CART */

    /**
     *
     * @returns {undefined}
     */
    function reloadPgCartItems() {
        let $targetElement = $('.nfwEle-cart-itemlist');
        if (!$targetElement.length) {
            return;
        }

        let url = `/ajax-pages/cart/itemlist/`;

        attachSpinner($targetElement);

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);
                    $targetElement.html(responseData);
                    czTheme.lazyloadUpdate();
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Reloading nfwEle-cart-itemlist failed!');
                    console.error('Reloading nfwEle-cart-itemlist failed!');
                })
                ;
    }

    /**
     *
     * @returns {undefined}
     */
    function reloadPgCartDetails() {
        let $targetElement = $('.nfwEle-cart-details');
        if (!$targetElement.length) {
            return;
        }

        let url = `/ajax-pages/cart/details/`;

        attachSpinner($targetElement);

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);
                    $targetElement.html(responseData);
                    czTheme.lazyloadUpdate();
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Reloading nfwEle-cart-details failed!');
                    console.error('Reloading nfwEle-cart-details failed!');
                })
                ;
    }

    /**
     *
     * @param {type} selector
     * @returns {undefined}
     */
    function interactionQuantityChange(selector) {

        $('body').on('click', selector, (event) => {
            //console.log('interactionQuantityChange', event);

            let $btn = $(event.currentTarget);
            let dir = $btn.data('quantity-direction');
            //console.log($btn, dir);

            let $input = $btn.parents('.input-group').find('input[type=number]');
            let val = parseFloat($input.val()) || 1;
            let step = parseFloat($input.attr('step')) || 1;
            let min = parseFloat($input.attr('min')) || 0;
            let max = parseFloat($input.attr('max')) || 1;
            //console.log($input, val, step, min, max);
            let newVal = null;

            if (dir === 'down') {
                newVal = val - step;
                if (newVal < min) {
                    newVal = min;
                }
            } else if (dir === 'up') {
                newVal = val + step;
                if (newVal > max) {
                    newVal = max;
                }
            }

            if (newVal !== null) {
                $input.val(newVal).trigger('change');
            }
        });
    }

    /**
     *
     * @param {string} selector
     * @returns {undefined}
     */
    function interactionCartUpdate(selector) {
        let fieldSel = 'input.nfwField-quantity';

        let $form = $(selector);
        if (!$form.length) {
            return;
        }

        let timeoutMS = 500;
        let timeoutID = null;
        $form.on('change', fieldSel, (event) => {
            //console.log(event);
            timeoutID ? clearTimeout(timeoutID) : null; // clear previous
            timeoutID = setTimeout(() => {
                $form.submit();
            }, timeoutMS); // set new
            //$form.submit();
        });
    }

    /* /CART */


    /* CHECKOUT */

    /**
     *
     * @returns {undefined}
     */
    function reloadPgCheckoutDetails() {
        let $targetElement = $('.nfwEle-checkout-details');
        if (!$targetElement.length) {
            return;
        }

        let url = `/ajax-pages/checkout/details/`;

        attachSpinner($targetElement);

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);
                    $targetElement.html(responseData);
                    czTheme.lazyloadUpdate();
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Reloading nfwEle-checkout-details failed!');
                    console.error('Reloading nfwEle-checkout-details failed!');
                })
                ;
    }

    /**
     *
     * @returns {undefined}
     */
    function reloadPgCheckoutShipping() {
        let selector = '.nfwEle-checkout-shipping';
        let $targetElement = $(selector);
        if (!$targetElement.length) {
            return;
        }

        let url = `/ajax-pages/checkout/shipping/`;

        attachSpinner($targetElement);

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);
                    myReplaceWith($targetElement, selector, responseData);
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Reloading ' + selector + ' failed!');
                    console.error('Reloading ' + selector + ' failed!');
                })
                ;
    }

    /**
     *
     * @returns {undefined}
     */
    function reloadPgCheckoutPayment() {
        let selector = '.nfwEle-checkout-payment';
        let $targetElement = $(selector);
        if (!$targetElement.length) {
            return;
        }

        let url = `/ajax-pages/checkout/payment/`;

        attachSpinner($targetElement);

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);
                    myReplaceWith($targetElement, selector, responseData);
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Reloading ' + selector + ' failed!');
                    console.error('Reloading ' + selector + ' failed!');
                })
                ;
    }

    /*
     * ********
     * Collapse
     * ********
     */

    /**
     *
     * @param {string} selector
     * @param {string} rootSelector
     * @returns {undefined}
     */
    function interactionCollapseCheckbox(selector, rootSelector = null) {

        let $rootElement = null;
        if (rootSelector !== null) {
            $rootElement = $(rootSelector);
            if (!$rootElement.length) {
                return;
            }
        } else {
            $rootElement = $('body');
        }

        /**
         *
         * @param {jEvent} event
         * @param {object} block
         * @param {object} panel
         * @param {bool} value
         * @returns {undefined}
         */
        function __value(event, block, panel, value) {
            let inputId = panel.dataset.elementInputId,
                    input = null;
            if (!inputId || !(input = document.querySelector(inputId))) {
                return;
            }

            input.checked = value;
            input.dispatchEvent(new Event('change', {bubbles: true}));
        }

        /**
         *
         * @param {jEvent} event
         * @returns {undefined}
         */
        function __event(event) {
            console.log({
                event: event,
            });

            let block = event.currentTarget;
            let panel = event.target;
            let show = event.type === 'show';
            let par = {
                cbk_pre: block.dataset.nfwCollapse_callbackPre || '',
                cbk_post: block.dataset.nfwCollapse_callbackPost || ''
            };
            console.log(par);

            if (par.cbk_pre) {
                _tryCallNFWCallback(par.cbk_pre, event, block, panel, show);
            }
            __value(event, block, panel, show);
            if (par.cbk_post) {
                _tryCallNFWCallback(par.cbk_post, event, block, panel, show);
            }
        }

        $rootElement.on('show.bs.collapse', selector, __event);
        $rootElement.on('hide.bs.collapse', selector, __event);
    }

    /**
     *
     * @param {string} selector
     * @param {string} rootSelector
     * @returns {undefined}
     */
    function interactionCollapseRadio(selector, rootSelector = null) {

        let $rootElement = null;
        if (rootSelector !== null) {
            $rootElement = $(rootSelector);
            if (!$rootElement.length) {
                return;
            }
        } else {
            $rootElement = $('body');
        }

        /**
         *
         * @param {jEvent} event
         * @param {bool} value
         * @returns {undefined}
         */
        function __value(event, value) {
            let target = event.target,
                    inputId = target.dataset.elementInputId,
                    input = null;
            if (!inputId || !(input = document.querySelector(inputId))) {
                return;
            }

            input.checked = value;
            input.dispatchEvent(new Event('change', {bubbles: true}));
        }

        /**
         *
         * @param {jEvent} event
         * @param {bool} checkSleepers
         * @returns {undefined}
         */
        function __check_active_bg(event, checkSleepers = false) {
            let activeClass = 'active';
            let target = event.target,
                    inputId = target.dataset.elementInputId,
                    input = null,
                    parent = event.currentTarget,
                    child = target;
            if (!inputId || !(input = document.querySelector(inputId))) {
                return;
            }

            // traverse to top element under parent
            while (child !== null && child.parentElement !== null && child.parentElement !== parent) {
                child = child.parentElement;
            }

            if (input.checked) {
                // do set background (this or root's)
                child.style.background = child.dataset.backgroundActive || parent.dataset.backgroundActive;
                child.classList.add(activeClass);
            } else {
                // do unset background
                child.style.background = '';
                child.classList.remove(activeClass);
            }

            if (checkSleepers) {
                // sleepers
                // foreach parent's children if had class active -> remove and unset bg
                parent.childNodes.forEach((element) => {
                    if (element.tagName && element.classList.contains(activeClass) && element !== child) {
                        element.style.background = '';
                        element.classList.remove(activeClass);
                    }
                });
            }

            return;
        }

        $rootElement.on('show.bs.collapse', selector, (event) => {
            console.log({
                selector: selector,
                name: 'show.bs.collapse',
                event: event,
            });
            __value(event, true);
            __check_active_bg(event, true);
        });
    }

    /*
     * *********
     * /Collapse
     * *********
     */

    /* /CHECKOUT */


    /* CATEGORY */

    /**
     *
     * @param {string} queryString
     * @param {bool} doScroll
     * @returns {undefined}
     */
    function reloadPgCategoryItemlist(queryString, doScroll = true) {
        let $targetElement = $('#nfwMod-category-itemlist');

        if (!$targetElement.length) {
            return;
        }

        if (!queryString) {
            queryString = window.location.search;
        }

        let categoryId = parseInt($targetElement.data('category-id'));
        let url = `/ajax-pages/category-itemlist/${categoryId}/${queryString}`;

        if (doScroll) {
            $targetElement.get(0).scrollIntoView(true);
        }

        attachSpinner($targetElement);

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);
                    $targetElement.replaceWith(responseData);
                    czTheme.lazyloadUpdate();
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Reloading `#nfwMod-category-itemlist` failed!');
                    console.error('Reloading `#nfwMod-category-itemlist` failed!');
                })
                ;
    }

    /**
     *
     * @param {string} queryString
     * @returns {int}
     */
    function reloadPgCategoryFilter(queryString) {
        let $targetElement = $('#nfwMod-category-filter');

        if (!$targetElement.length) {
            return;
        }

        if (!queryString) {
            queryString = window.location.search;
        }

        let categoryId = parseInt($targetElement.data('category-id'));
        let url = `/ajax-pages/category-filter/${categoryId}/${queryString}`;

        attachSpinner($targetElement);

        $.get(url)
                .done((responseData, textStatus, jqXHR) => {
                    //console.log(responseData);
                    //$targetElement.replaceWith(responseData);
                    $targetElement.parent().html(responseData); // replace whole parent's content
                    czTheme.rangeSlider();
                    czTheme.filterList();
                })
                .fail((jqXHR, textStatus, httpStatus) => {
                    //message2toast('danger', 'Reloading `#nfwMod-category-filter` failed!');
                    console.error('Reloading `#nfwMod-category-filter` failed!');
                })
                ;

        return categoryId;
    }

    /**
     *
     * @param {string} selList
     * @param {string} selFilters
     * @returns {undefined}
     */
    function loadPostponedCategoryModules(selList, selFilters) {

        if ($(selList).hasClass('nfwX-category-itemlist-postponed')) {
            reloadPgCategoryItemlist('', false);
        }

        if ($(selFilters).hasClass('nfwX-category-filter-postponed')) {
            reloadPgCategoryFilter('');
        }

    }

    /**
     *
     * @param {string} method
     * @returns {undefined}
     */
    function moduleRecomendedProducts(method) {
        let element = $('#nfwMod-recomended-products');

        if (method === 'hide') {
            element.remove();
        }
    }

    /**
     *
     * @param {bool} doScroll
     * @returns {undefined}
     */
    function applyPgCategoryFilter(doScroll = false, dummy = false) {

        let $form = $('#nfwMod-category-filters');
        //console.log($form);
        let queryString = '?' + form2query($form);
        console.log(queryString);

        if (!dummy) {
            window.history.pushState("", "", queryString);
            reloadPgCategoryItemlist(queryString, doScroll);
            moduleRecomendedProducts('hide');
        }
        let categoryId = reloadPgCategoryFilter(queryString);
        reloadLayoutToolbarFilters(categoryId, queryString);
    }

    /**
     *
     * @returns {undefined}
     */
    function interactionCategoryFilterButtons() {
        let $targetElement = $('#shop-sidebar');
        if (!$targetElement.length) {
            return;
        }

        // disable default onchange action?

        let $tEleApply = $targetElement.find('button.nfwEle-category-filters-apply');
        let $tEleDiscard = $targetElement.find('button.nfwEle-category-filters-discard');

        $tEleApply.click(() => {
            applyPgCategoryFilter(true);
            //hide sidebar
        });

        $tEleDiscard.click(() => {
            // zrychlí skrytí panelu / není vidět že se reloaduje prvek / odloží reload - v tom čase je panel již schovaný
            setTimeout(reloadPgCategoryFilter, 1000);
        });
    }

    /**
     *
     * @param {string} selector
     * @returns {undefined}
     */
    function interactionCategoryFilter(selector) {
        let $targetElement = $('#shop-sidebar');
        if (!$targetElement.length) {
            return;
        }

//        let timeoutMS = 10; // almost none
//        let timeoutID = null;
        $targetElement.on('change', selector + ' input.nfwE-filter-trigger', (event) => {
            //console.log(event);
            let mv = czTheme.isMobileView();
            applyPgCategoryFilter(false, mv);
//            if (!czTheme.isMobileView()) {
//                if (timeoutID) {
//                    // clear previous
//                    clearTimeout(timeoutID);
//                }
//                // set new
//                timeoutID = setTimeout(applyPgCategoryFilter, timeoutMS, false, mv);
//            }
        });
    }

    /**
     *
     * @param {string} selectorbase
     * @returns {undefined}
     */
    function interactionCategoryPagination(selectorbase) {
        let selector = selectorbase + ' a.nfwE-page-link';
        //console.log(selector);

        let $targetElement = $(selectorbase);
        if (!$targetElement.length) {
            return;
        }

        $('body').on('click', selector, (event) => {
            //console.log(event);
            let queryString = event.currentTarget.href;
            console.log(queryString);

            reloadPgCategoryItemlist(queryString, true);
            window.history.pushState("", "", queryString);

            return false;
        });
    }

    /**
     *
     * @param {string} selectorbase
     * @returns {undefined}
     */
    function interactionCategoryViewChange(selectorbase) {
        let selector = selectorbase + ' a.nfwE-itemlist-viewchange';
        //console.log(selector);

        let $targetElement = $(selectorbase);
        if (!$targetElement.length) {
            return;
        }

        $('body').on('click', selector, (event) => {
            //console.log(event);
            let queryString = event.currentTarget.href;
            console.log(queryString);

            reloadPgCategoryItemlist(queryString, false);
            reloadPgCategoryFilter(queryString);
            window.history.pushState("", "", queryString);

            return false;
        });
    }

    /* /CATEGORY */


    /* GLOBAL CALLBACKS */

    window.NFWCallbacks = {};

    /**
     * @param {String} name
     * @param {Array} args
     * @returns {undefined|mixed}
     */
    function _tryCallNFWCallback(name, ...args) {

        let fn = window.NFWCallbacks[name];
        if (typeof fn === 'function') {
//            // spread
//            let args = [...arguments];
//            // remove firs
//            args.shift();
//            // call
            console.info(`Calling NFWCallback '${name}'`);
            return fn.apply(null, args);
        }
        console.error(`Provided NFWCallback '${name}' is not defined!`);
        return;
    }

    /**
     * data-nfw-ajaxed_callback-success="submitDone_setShipping"
     *
     * @param {jEvent} event
     * @param {Object} responseData
     * @returns {undefined}
     */
    window.NFWCallbacks.submitDone_setShipping = function (event, responseData) {
        reloadPgCheckoutPayment();
        reloadPgCheckoutDetails();
    };

    /**
     * data-nfw-ajaxed_callback-success="submitDone_setPayment"
     *
     * @param {jEvent} event
     * @param {Object} responseData
     * @returns {undefined}
     */
    window.NFWCallbacks.submitDone_setPayment = function (event, responseData) {
        reloadPgCheckoutDetails();
    };

    /**
     * data-nfw-ajaxed_callback-success="submitDone_addToCart"
     *
     * @param {jEvent} event
     * @param {Object} responseData
     * @returns {undefined}
     */
    window.NFWCallbacks.submitDone_addToCart = function (event, responseData) {
        showModalAddedToCart();
        reloadLayoutCart();
    };

    /**
     * data-nfw-ajaxed_callback-success="submitDone_updateCart"
     *
     * @param {jEvent} event
     * @param {Object} responseData
     * @returns {undefined}
     */
    window.NFWCallbacks.submitDone_updateCart = function (event, responseData) {
        reloadLayoutCart();
        reloadPgCartItems();
        reloadPgCartDetails();
    };

    /**
     * data-nfw-ajaxed_callback-success="submitDone_removeCart"
     *
     * @param {jEvent} event
     * @param {Object} responseData
     * @returns {undefined}
     */
    window.NFWCallbacks.submitDone_removeCart = function (event, responseData) {
        //console.error({event, responseData});
        if (responseData.success && responseData.data.pocetPolozek === 0) {
            // odebrána poslední položka, refreshni
            window.location.href = responseData.redirect;
            return;
        }
        _tryCallNFWCallback('submitDone_updateCart', event, responseData);
    };

    /**
     * data-nfw-ajaxed_callback-success="submitDone_cookies"
     *
     * @param {jEvent} event
     * @param {Object} responseData
     * @returns {undefined}
     */
    window.NFWCallbacks.submitDone_cookies = function (event, responseData) {
        //console.log(event, responseData);
        $('#toast-cookie-info').toast('hide');
    };

    let continue_checkoutFinish = null;

    /**
     * data-nfw-ajaxed_callback-success="submitDone_cookies"
     *
     * @param {jEvent} event
     * @param {Object} responseData
     * @returns {undefined}
     */
    window.NFWCallbacks.submitDone_checkoutDetails = function (event, responseData) {
        console.log(arguments);
        if (typeof continue_checkoutFinish === 'function') {
            continue_checkoutFinish();
        }
    };

    /**
     *
     * @param {jEvent} event
     * @param {DOMObject} form
     * @param {function} fncContinue
     */
    window.NFWCallbacks.presubmit_checkoutFinish = function (event, form, fncContinue) {
        console.log(arguments);
        continue_checkoutFinish = fncContinue;

//        $('#nfwForm-checkout-details').submit();

        $('#nfwForm-checkout-details').trigger('submit');

//        let triggerEle = document.querySelector('#nfwForm-checkout-details');
//        let triggerEvt = new Event('submit', {bubbles: false, cancelable: true});
//        triggerEle.dispatchEvent(triggerEvt);

        return false;
    };

    /**
     * data-nfw-collapse_callback-post="collapseChange_required"
     *
     * @param {jEvent} event
     * @param {Object} block
     * @param {Object} panel
     * @param {bool} value
     * @returns {undefined}
     */
    window.NFWCallbacks.collapseChange_required = function (event, block, panel, value) {
        //console.log(event, block, panel, value);
        panel.querySelectorAll('input').forEach((ele) => {

            ele.required = value;

            let rq = panel.querySelector(`label[for=${ele.id}] > sup`);
            if (!rq) {
                return;
            }
            if (value) {
                rq.classList.remove('d-none');
            } else {
                rq.classList.add('d-none');
            }
        });
    };

    /* /GLOBAL CALLBACKS */


    /* CALL */

    runToasts();

    interactionCollapsibleSubmenu('.nfwEle-submenu-collapse-stopper');

    modalOrderDetail('#modal-order-details');
    modalProductQuick('#modal-product-quick');
    modalAddress('#modal-address-add', false);
    modalAddress('#modal-address-edit', true);
    modalShippingPickup('.nfwModal-shippingPickup');

    interactionAJAXedLink('a.nfwLink-ajaxed');
    interactionAJAXedForm('form.nfwForm-ajaxed');

    interactionFormSubmitOn('change', '.nfwEle-checkout-shipping-input, .nfwEle-checkout-payment-input', '.nfwEle-checkout-section');
    interactionStoreOnChange('form.nfwForm-store-on-change');

    interactionSearchDynamic('form.nfwForm-search-dynamic');

    interactionQuantityChange('button.nfwEle-cartitem-quantity');
    interactionCartUpdate('form.nfwForm-cart-update');

    interactionCategoryPagination('#nfwMod-category-itemlist');
    interactionCategoryViewChange('#nfwMod-category-itemlist');
    interactionCategoryFilterButtons();
    interactionCategoryFilter('#nfwMod-category-filters');

    interactionCollapseCheckbox('.nfwEle-collapse-checkbox', '.nfwEle-checkout-section');
    interactionCollapseRadio('.nfwEle-collapse-radio', '.nfwEle-checkout-section');

    loadPostponedCategoryModules('#nfwMod-category-itemlist', '#nfwMod-category-filter');

    /* /CALL */

})(window, document, jQuery, window.czTheme, window.czTheme.console);
